import {Component, NgZone, OnInit} from '@angular/core';
import {AppService} from './app.service';
declare let paypal: any;
declare let $: any;


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(public app: AppService, private zone: NgZone) {

  }

  ngOnInit() {

  }
}
